import { ownerInitials, useAppBar } from '../app/AppBar';
import { useSession } from '../auth/SessionProvider';
import styles from './settings.module.css';

/**
 * Account and preferences. The owner's own settings, including the automatic-review switch
 * (disabled in V1 until its documented measurement gate and explicit opt-in - CLAUDE.md rule 3),
 * arrive in a later subphase; signing out lives here because this is where account actions
 * belong, reached from the app bar's avatar.
 */
export function SettingsScreen() {
  const { owner, logout } = useSession();

  useAppBar(() => ({ title: 'Ajustes' }), []);

  return (
    <div className={styles.screen}>
      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>Tu cuenta</h2>
        {owner === null ? null : (
          <div className={styles.accountRow}>
            <span className={styles.avatar} aria-hidden="true">
              {ownerInitials(owner.email)}
            </span>
            <span className={styles.email}>{owner.email}</span>
          </div>
        )}
        <button
          type="button"
          className={styles.logoutButton}
          onClick={() => {
            void logout();
          }}
        >
          Cerrar sesión
        </button>
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>Preferencias</h2>
        <p className={styles.hint}>
          Aquí vas a administrar tus preferencias. Esta pantalla llega en una próxima etapa.
        </p>
      </section>
    </div>
  );
}
